import styled from 'styled-components'
import { FlexRow } from 'components/common/common_styles'
import { Caption1, StyledButton } from 'components/common/typography'
import { sizeMobile } from 'components/globalStyles'

export const MainContainer = styled.dialog`
  display: block;
  position: absolute;
  left: ${props => props.$offset}px;
  bottom: -4px;
  padding: 16px;
  z-index: 1;
  background: white;
  pointer-events: all;
  transform: translateY(100%);
  border: none;
  filter: drop-shadow(0 1px 16px rgba(17, 17, 17, 0.1));

  @media (max-width: ${sizeMobile}) {
    position: fixed;
    width: 100vw;
    height: calc(100vh - 64px);
    top: 64px;
    left: 0;
    bottom: auto;
    transform: none;
    filter: none;
    background: white;
    padding-top: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 100;

    & label {
      font-size: 1.8rem;
    }
  }
`

export const CalendarPrice = styled(Caption1)`
  font-weight: normal;

  @media (max-width: ${sizeMobile}) {
    font-size: 1.3rem;
  }
`

export const DropdownRow = styled(FlexRow)`
  justify-content: center;
  margin-top: 4px;

  & select {
    padding: 4px;
  }
`

export const ApplyButton = styled(StyledButton)`
  margin-top: 24px;
  width: 92%;
`
